import type { ApplicationDetail } from '@/entities/application/model/types';
import type { AdminApplicationUpdateForm } from '../model/schema';
import { parseJapaneseDate } from './parseJapaneseDate';

/**
 * APIレスポンス（ApplicationDetail）からフォーム初期値に変換する
 *
 * @param detail APIから取得した申込詳細データ（undefinedの場合は空のフォーム値を返す）
 * @returns 管理者向け申込更新フォームの初期値
 */
export const buildFormFromApplicationDetail = (detail?: ApplicationDetail): AdminApplicationUpdateForm => {
    return {
        // お客様情報
        reservationHolderName: detail?.customer_info.reservation_holder_name ?? '',
        userName: detail?.customer_info.user_name ?? '',
        relationshipWithGuest: detail?.customer_info.relationship_with_guest ?? '',
        email: detail?.customer_info.email ?? '',
        phoneNumber: detail?.customer_info.phone_number ?? '',
        isPhoneValid: true, // IntlTelInputの初期値（既存データは有効とみなす）
        countryName: detail?.customer_info.country_name ?? '',

        // ホテル情報
        hotelId: detail?.hotel_info.id ?? '',
        checkInDate: parseJapaneseDate(detail?.hotel_info.check_in_date),
        checkOutDate: parseJapaneseDate(detail?.hotel_info.check_out_date),
    };
};
